/**
 * Messages & SMS API Service
 *
 * Handles all messaging-related API calls:
 * - Get messages
 * - Send messages
 * - Broadcast credentials
 * - Download mail
 */

import { post } from './client';

export const messagesApi = {
    /**
     * Get all messages for a landlord
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} List of messages
     */
    getAll: async (landlordId) => {
        return post('pegasus/visionary/messages/', {
            id: landlordId,
        });
    },

    /**
     * Send a message
     * @param {Object} messageData
     * @param {string} messageData.sender - Sender type (e.g., "landlord")
     * @param {string} messageData.sender_id - Sender ID
     * @param {string} messageData.recipient_id - Recipient ID
     * @param {string} messageData.message - Message content
     * @returns {Promise<Object>} Send response
     */
    send: async (messageData) => {
        return post('pegasus/visionary/messages/send', messageData);
    },

    /**
     * Broadcast credentials to tenants
     * @param {Object} broadcastData - Broadcast details
     * @returns {Promise<Object>} Broadcast response
     */
    broadcastCredentials: async (broadcastData) => {
        return post('pegasus/visionary/messages/broadcast/credentials', broadcastData);
    },
};

/**
 * Mail API Service
 */
export const mailApi = {
    /**
     * Download mail
     * @param {Object} mailData - Mail download data
     * @returns {Promise<Object>} Mail download response
     */
    download: async (mailData) => {
        return post('pegasus/visionary/mails/download', mailData);
    },
};

export default messagesApi;
